import { Button, ButtonGroup, DateTimeInput, Field, NumericInput, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import { IWithWorksheetInjectedProps } from 'Components/Worksheets/Core';
import { TareId } from 'Components/Worksheets/Core/Fields/TareId';
import { createDryMassEntryOptionSelector } from 'Components/Worksheets/MoistureContentWorksheet';
import { VolumeDeterminationMethod } from 'Components/Worksheets/MoistureContentWorksheet/BsEn/types';
import { actions } from 'Data/ReduxViewModels/WorksheetEditor';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import deepEquals from 'Lib/Object/deepEquals';
import { useDispatch, useSelector } from 'react-redux';

let BsEnMeasurementsSingleTraySection: React.FC<IWithWorksheetInjectedProps> = ({
  createWorksheetSelector,
  prefixName,
}) => {
  const dispatch = useDispatch();

  const showTimeInOven = useSelector(
    pipe(createDryMassEntryOptionSelector(createWorksheetSelector!), (v) => v !== 'Never')
  );

  const lightweightAggregate = useSelector(
    pipe(createWorksheetSelector!('Preparation.LightweightAggregate'), valueOrDefault(false))
  );

  const isBulkDensity = useSelector(
    pipe(
      createWorksheetSelector!('Measurements.VolumeDeterminationMethod'),
      (p) => p === VolumeDeterminationMethod.BulkDensity
    )
  );
  const trays = useSelector(createWorksheetSelector!('DryingTrays'), deepEquals) as any[];

  const updateTrays = (value: any[]) => {
    dispatch(
      actions.setValue({
        name: prefixName!('DryingTrays'),
        value: value,
        sync: true,
      })
    );
  };

  return (
    <ListFieldSection>
      <TareId name="DryingTrays[0].ContainerLabel" />
      <Field input={<NumericInput />} name="DryingTrays[0].ContainerMass" />
      <FieldSet>
        <Field input={<NumericInput />} name="DryingTrays[0].WetSoilAndContainerMass" />
        <ButtonGroup>
          <Button onClick={() => updateTrays([...trays, {}])}>Add Tray</Button>
        </ButtonGroup>
      </FieldSet>
      <Field
        input={<TextOutput />}
        name="DryingTrays[0].WetSoilMass"
        additionalMessagePaths={['Measurements.TotalWetMass']}
      />
      <Field input={<TextOutput />} name="Measurements.Volume" visible={lightweightAggregate && isBulkDensity} />
      {showTimeInOven && <Field input={<DateTimeInput />} name="DryingTrays[0].DateTimePlacedInOvenLocal" />}
    </ListFieldSection>
  );
};
BsEnMeasurementsSingleTraySection = withInjectedProps(BsEnMeasurementsSingleTraySection);

export { BsEnMeasurementsSingleTraySection };
